import { Action } from '@ngrx/store'

import { VendorTeamV1 } from '../../../../api/api/models/vendor-team-v1'
import { TeamImage } from '../../../../teams/team-info/team-image'
import { VendorTeamUpdatedIE } from '../../../signalR/models/integration-events/vendor-team-updated-ie'

// Create
export const CREATE_TEAM = '[Team] create team'
export const CREATE_TEAM_SUCCESS = '[Team] create team success'
// Retrieve
export const LOAD_TEAMS = '[Team] Load teams'
export const LOAD_TEAMS_SUCCESS = '[Team] Load teams success'
export const LOAD_TEAM = '[Team] Load one team'
export const LOAD_TEAM_SUCCESS = '[Team] Load one team success'
export const SELECT_TEAM_FOR_EDITING = '[Team] select team for editing'
export const SELECT_TEAM_FOR_EDITING_FILLED = '[Team] select team for editing filled'
export const SELECT_TEAM_FOR_EDITING_DONE = '[Team] select team for editing done'
// Update
export const UPDATE_TEAM_INFO = '[Team] update team info'
export const UPDATE_TEAM_SUCCESS = '[Team] update team success'
export const UPLOAD_TEAM_IMAGE = '[Team] upload team image'
export const UPLOAD_TEAM_IMAGE_SUCCESS = '[Team] upload team image success'
export const UPLOAD_TEAM_LOGO = '[Team] upload team logo'
export const UPLOAD_TEAM_LOGO_SUCCESS = '[Team] upload team logo success'
// remove
export const REMOVE_TEAM = '[Team] remove'
// External update
export const TEAM_UPDATED_EVENT = '[Team] vendor team updated event'
export const TEAM_UPDATED_EVENT_FINISH = '[Team] vendor team updated event finish'

export class LoadTeams implements Action {
  readonly type = LOAD_TEAMS
}

export class LoadTeamsSuccess implements Action {
  readonly type = LOAD_TEAMS_SUCCESS

  constructor(public payload: { teams: VendorTeamV1[] }) {
  }
}

export class LoadTeam implements Action {
  readonly type = LOAD_TEAM

  constructor(public payload: { vendorTeamId: number }) {
  }
}

export class LoadTeamSuccess implements Action {
  readonly type = LOAD_TEAM_SUCCESS

  constructor(public payload: { team: VendorTeamV1 }) {
  }
}

export class SelectTeamForEditing implements Action {
  readonly type = SELECT_TEAM_FOR_EDITING

  constructor(public payload: { selectingTeamId: number | 'new' }) {
  }
}

export class SelectTeamForEditingFilled implements Action {
  readonly type = SELECT_TEAM_FOR_EDITING_FILLED

  constructor(public payload: { selectingTeamId: number | 'new', editingTeamId: number }) {
  }
}

export class SelectTeamForEditingDone implements Action {
  readonly type = SELECT_TEAM_FOR_EDITING_DONE

  constructor(public payload: { selectingTeamId: number | 'new' }) {
  }
}

export class CreateTeam implements Action {
  readonly type = CREATE_TEAM

  constructor(public payload: { team: Partial<VendorTeamV1> }) {
  }
}

export class UpdateTeamInfo implements Action {
  readonly type = UPDATE_TEAM_INFO

  constructor(public payload: { team: VendorTeamV1 }) {
  }
}

export class UploadTeamImage implements Action {
  readonly type = UPLOAD_TEAM_IMAGE

  constructor(public payload: { image: TeamImage }) {
  }
}

export class UploadTeamImageSuccess implements Action {
  readonly type = UPLOAD_TEAM_IMAGE_SUCCESS

  constructor(public payload: { vendorTeamId: number, imgUrl: string }) {
  }
}

export class UploadTeamLogo implements Action {
  readonly type = UPLOAD_TEAM_LOGO

  constructor(public payload: { image: TeamImage }) {
  }
}

export class UploadTeamLogoSuccess implements Action {
  readonly type = UPLOAD_TEAM_LOGO_SUCCESS

  constructor(public payload: { vendorTeamId: number, logoImgUrl: string }) {
  }
}

export class UpdateTeamSuccess implements Action {
  readonly type = UPDATE_TEAM_SUCCESS

  constructor(public payload: { team: VendorTeamV1 }) {
  }
}

export class CreateTeamSuccess implements Action {
  readonly type = CREATE_TEAM_SUCCESS

  constructor(public payload: { team: VendorTeamV1 }) {
  }
}

export class RemoveTeam implements Action {
  readonly type = REMOVE_TEAM

  constructor(public payload: { vendorTeamId: number }) {
  }
}

export class UpdatedTeamEvent implements Action {
  readonly type = TEAM_UPDATED_EVENT

  constructor(public payload: { event: VendorTeamUpdatedIE }) {
  }
}

export class UpdatedTeamEventFinish implements Action {
  readonly type = TEAM_UPDATED_EVENT_FINISH

  constructor(public payload: VendorTeamUpdatedIE) {
  }
}

export type TeamActions =
  LoadTeams
  | LoadTeamsSuccess
  | LoadTeam
  | LoadTeamSuccess
  | SelectTeamForEditing
  | SelectTeamForEditingFilled
  | SelectTeamForEditingDone
  | UploadTeamImage
  | UploadTeamImageSuccess
  | UploadTeamLogo
  | UploadTeamLogoSuccess
  | UpdateTeamSuccess
  | CreateTeam
  | CreateTeamSuccess
  | UpdateTeamInfo
  | RemoveTeam
  | UpdatedTeamEvent
  | UpdatedTeamEventFinish



// WEBPACK FOOTER //
// ./src/app/shared/team/store/actions/team.actions.ts